/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//Componentd
import Loader from "../../../common/Loader";

//Redux
import { useSelector } from "react-redux"; //useDispatch

const Home = () => {
  const navigate = useNavigate();
  localStorage.setItem("menu", "Home");
  localStorage.setItem("submenu", "-");

  let menuData = useSelector((state) => state?.menu); // User Details from Store
  const handleClick = (hrefLink) => {
    navigate(hrefLink);
  };

  return (
    <main className="dashboard main homePage" id="main">
      <Row className="homeScreen justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">Home</h2>
            <p className="subText">Complete Details of the Manufacturing</p>
            <hr />
            <Loader isLoading={!menuData?.status} className="text-center" />
            <Row className="menu-top-modern mb-3">
              {menuData?.data
                ?.filter(
                  (menu) =>
                    !["Master", "Reports"].includes(menu.name)
                )
                .map((menu, idx) => (
                  menu.name !== "Home" &&
                  <Col xs={12} md={3} key={idx} className="commLeftRightPadding">
                    <div
                      className={`card info-card sales-card  hover-card  modern-card`}
                      onClick={() => handleClick(menu.hrefLink)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="card-body d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className={menu.icon}></i>
                        </div>
                        <div className="ps-3">
                          <h6>{menu.name}</h6>
                          <span
                            className="text-muted small pt-2"
                            style={{ fontWeight: "600" }}
                          >
                            {menu.description}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
            </Row>

            {menuData?.data
              ?.filter((menu) =>
                ["Master", "Reports"].includes(menu.name)
              )
              .map((section, idx) => (
                section.name !== "Home" &&
                <div
                  key={idx}
                  className={` menu-section ${section.name.toLowerCase() === "master"
                    ? "masters"
                    : section.name.toLowerCase() === "reports"
                      ? "reports"
                      : "transactions"
                    }`}
                >
                  <h3>{section.name}</h3>
                  <Row className="menu-top-modern mb-3">
                    {section.children?.map((child, index) => (
                      <Col
                        xs={12}
                        md={3}
                        className="commLeftRightPadding"
                        key={index}
                      >
                        <div
                          className="card info-card sales-card  hover-card  modern-card"
                          onClick={() => handleClick(child.hrefLink)}
                        >
                          <div className="card-body">
                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className={child.icon}></i>
                              </div>
                              <div className="ps-3">
                                <h6>{child.name}</h6>
                                <span
                                  className="text-muted small pt-2"
                                  style={{ fontWeight: "600" }}
                                >
                                  {child.description}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              ))}
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default Home;
